<template>
  <v-layout row wrap>

    <v-flex d-flex xs12 mt-4>
      <v-layout row wrap align-center class="text-xs-left">
        <v-flex xs12 class="pr-4">
          Please confirm the store details by using <span v-if="!quick">Store ID:</span>
        </v-flex>

        <v-flex d-flex xs12 >
          <v-text-field
            @keyup="changedInput=true"
            @keyup.enter="validateStore"
            v-validate="'required'"
            :error-messages="errors.collect('slot1.storeCode')"
            data-vv-name="slot1.storeCode"
            data-vv-scope="slot1"
            data-vv-validate-on="blur"
            v-model="storeCode"
            :disabled="storeDetails.storeId !== ''"
            label="Store ID"
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 style="margin-top: 10px;" v-if="storeDetails.storeId">
          <v-flex xs6 text-xs-right pr-2><strong>Store Name:</strong></v-flex>
          <v-flex xs6>{{storeDetails.name}}</v-flex>
        </v-flex>
        <v-flex d-flex xs12 style="margin-bottom: 10px;" v-if="storeDetails.storeId">
          <v-flex xs6 text-xs-right pr-2> <strong>Location:</strong></v-flex>
          <v-flex xs6>
            {{storeDetails.address}} <br>{{storeDetails.city}}, {{storeDetails.state}} {{storeDetails.zip}} <br>
          </v-flex>
        </v-flex>
        <v-flex d-flex xs12 class="mt-0" v-if="!storeDetails.storeId">
          <v-btn @click="validateStore"
                 :disabled="!changedInput || !storeCode"
                 :loading="loading" class="ml-0 mr-0 "
                 color="success">Confirm Store ID</v-btn>
        </v-flex>

        <v-flex d-flex xs12 class="mt-0" v-if="storeDetails.storeId">
          <v-flex :class="quick ? 'xs12 px-4':'xs6 pr-1'">
            <v-layout column justify-content-center v-if="quick">
              <v-flex>
                <v-btn outline block @click="resetStoreDetails" color="primary">Change Store ID</v-btn>
              </v-flex>
            </v-layout>
            <v-layout column justify-content-center v-else>
              <v-flex>
                <v-btn block @click="resetStoreDetails" color="primary">&#8592; Back</v-btn>
              </v-flex>
              <v-flex>
                <em>Try another Store ID</em>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6 text-xs-right pl-1 v-if="!quick" >
            <v-btn @click="goToPasswordPage" block
                   color="success">&check;&nbsp;Yes, Continue</v-btn>
          </v-flex>
        </v-flex>


        <v-flex d-flex xs12 v-if="!storeDetails.storeId">
          <v-btn v-if="!quick" class="mr-0 ml-0" @click="goBack" color="primary">&#8592; Back</v-btn>
        </v-flex>

        <v-flex mt-5 v-if="!quick">
          <v-layout>
            <v-flex align-center xs7 sm6 class="text-xs-right mt-3 pr-1 align-content-center">
              <em>Don't know your Store ID?<br>Ask your manager!</em>
            </v-flex>

            <v-flex xs5 sm6 class="text-xs-left mt-3 pl-2">
              <img src="@/assets/images/store.svg" height="80" alt="store" title="store"/>
            </v-flex>
          </v-layout>
        </v-flex>

      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'
const DEFAULT_STORE_DETAILS = {
  storeId: '',
  name: '',
  address: '',
  city: '',
  state: '',
  country: '',
  zip: ''
}

export default {
  name: 'StoreVerification',
  data () {
    return {
      storeDetails: DEFAULT_STORE_DETAILS,
      loading: false,
      changedInput: false,
      storeCode: '',
      errorMsg: 'Please enter Store ID',
      dictionary: {
        custom: {
          'slot1.storeCode': {
            required: () => this.errorMsg,
            length: 'Please enter Store ID'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    },
    quick: {
      default: false,
      type: Boolean
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    if (this.getUserDetails.store_details.name) {
      this.storeDetails = this.getUserDetails.store_details
      this.storeCode = this.getUserDetails.store_details.storeId
    }
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    email () {
      return this.decryptData(this.getUserDetails.email)
    },
    emailVerified () {
      return this.getUserDetails.email_verified
    }
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    goBack () {
      this.goToSignupStep(this.page, 'confirm-my-email')
    },
    resetStoreDetails () {
      this.storeCode = ''
      this.storeDetails = {...DEFAULT_STORE_DETAILS}
      this.setUser({...this.getUserDetails, store_verified: true, store_details: {...DEFAULT_STORE_DETAILS}})
    },
    goToPasswordPage () {
      this.$router.push({name: 'SignUp', params: {step: 'get-name-and-pwd', email: this.$route.params.email}})
    },
    validateStore () {
      console.log(this.errors.storeCode)
      this.errors.clear('slot1')
      this.storeDetails = DEFAULT_STORE_DETAILS
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          this.$http({
            url: process.env.API_URL + '/ws/userservice/store/' + this.storeCode,
            method: 'GET'
          }).then((res) => {
            if (res.data.storeId) {
              this.storeDetails = res.data
              this.loading = false
              this.setUser({...this.getUserDetails, store_verified: true, store_details: this.storeDetails})
            } else {
              // this.setUser({...this.getUserDetails, email_verified: false})
              this.loading = false
              this.errors.add({
                field: 'storeCode',
                msg: 'Invalid Store ID'
              })
            }
          }).catch(() => {
            this.loading = false
            this.errors.add({
              scope: 'slot1',
              field: 'storeCode',
              msg: 'Invalid Store ID'
            })
          })
        }
      })
    }
  },
  mixins: [crypto, common]
}
</script>



// WEBPACK FOOTER //
// src/components/views/sign-up/62/StoreVerification.vue